const LOAD = 'COUNTRIES/COUNTRIES/LOAD';
const LOAD_SUCCESS = 'COUNTRIES/COUNTRIES/LOAD_SUCCESS';
const LOAD_FAIL = 'COUNTRIES/COUNTRIES/LOAD_FAIL';

const initialState = () => ({
  loaded: false,
  editing: {},
  loading: false,
  countries: {},
  error: '',
});

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: '',
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        countries: {
          ...state.countries,
          [action.name]: action.result,
        },
        error: ''
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        tours: null,
        error: typeof action.error === 'string' ? action.error : 'Error'
      };
    default:
      return state;
  }
}

export function isCountryLoaded(globalState, countryName = '') {
  return globalState?.countries?.countries[countryName];
}

export function loadCountry(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: ({ client }) => client.get('/countries/load/', {
      params: {
        name
      }
    }),
    name,
  };
}
